export default "__VITE_ASSET__CAaob8tk__"